class Top {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    this.initMvSwiper();
    this.initAboutTabSwipers();
    this.initAboutTab();
  }

  initMvSwiper() {
    new Swiper('.js-top-mv-swiper', {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.js-top-mv-swiper .swiper-pagination',
        clickable: true,
      },
    });
  }

  initAboutTabSwipers() {
    this.aboutTabSwipers = [];
    document.querySelectorAll('.js-about-tab-swiper').forEach((el) => {
      const slideCount = el.querySelectorAll('.swiper-slide').length;
      const wrapper = el.closest('.p-top-about__tab-slider-wrapper');

      if (slideCount <= 1) {
        if (wrapper) wrapper.classList.add('is-single');
        this.aboutTabSwipers.push(null);
        return;
      }

      const panel = el.closest('.p-top-about__tab-panel') || el.parentElement;
      const paginationEl = panel ? panel.querySelector('.p-top-about__tab-pagination') : null;
      const swiper = new Swiper(el, {
        loop: true,
        speed: 600,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });
      this.aboutTabSwipers.push(swiper);
    });
  }

  initAboutTab() {
    const tabBtns = document.querySelectorAll('.p-top-about__tab-btn');
    const tabPanels = document.querySelectorAll('.p-top-about__tab-panel');
    const tabBody = document.querySelector('.p-top-about__tab-body');

    if (!tabBtns.length) return;

    tabBtns.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        tabBtns.forEach((b) => b.classList.remove('is-active'));
        tabPanels.forEach((p) => p.classList.remove('is-active'));

        btn.classList.add('is-active');
        tabPanels[index].classList.add('is-active');

        if (tabBody) {
          tabBody.dataset.activeTab = index;
        }

        if (this.aboutTabSwipers[index]) {
          this.aboutTabSwipers[index].update();
        }
      });
    });
  }
}
